<div class="sidebar">
  <div class="top-wrapper">
    <button class="cmn-close" (click)="close()"></button>
    <h4>Custom Reminder</h4>
  </div>
  <div class="middle-wrapper">
    <!-- <div class="search-wrapper">
        <div class="search-icon">
          <img
            src="../../../../assets/images/icons/lens-search.svg"
            alt="search-icon"
            srcset=""
          />
        </div>
        <input
          type="text"
          name=""
          id=""
          placeholder="Select Skill"
          class="select-skill"
        />
      </div> -->
    <div *ngFor="let reminder of customReminders" class="reminder-card">
      <div class="reminder-header">
        <h5>{{ reminder.title }}</h5>
        <span class="status" [ngClass]="reminder.reminderStatus">
          {{ reminder.reminderStatus }}
        </span>
      </div>
      <div class="reminder-details">
        <div class="reminder-details__left">
          <div>{{ reminder.description }}</div>
          <div class="meta">
            <span>Type: {{ reminder.reminderType }}</span>
            <span>Priority: {{ reminder.priority }}</span>
            <span>Channel: {{ reminder.channel }}</span>
          </div>
          <div class="dates">
            <ng-container *ngIf="reminder.dueAt">
              <span>Due:   {{ reminder.dueAt | date: 'MMM d, yyyy, h:mm a' }}</span>
            </ng-container>
            <ng-container *ngIf="reminder.startAt">
              <span>Start:    {{ reminder.startAt | date: 'MMM d, yyyy, h:mm a' }}</span>
            </ng-container>
            <ng-container *ngIf="reminder.endAt">
              <span>End:   {{ reminder.endAt | date: 'MMM d, yyyy, h:mm a' }}</span>
            </ng-container>
          </div>
        </div>
        <div class="reminder-details__right">
          <div class="icon" (click)="openReminderModal(reminder.id)">
            <img src="assets/images/icons/icon-edit-profile.svg" alt="edit">
          </div>
          <div class="icon" (click)="onDeleteReminder(reminder.id)">
            <img src="assets/images/icons/icon-delete.svg" alt="delete">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bottom-wrapper">
    <!-- <h5>6 Questions Added</h5> -->
    <button class="primary-button cmn-add-btn" (click)="openReminderModal()">
      Add Reminder
    </button>
  </div>
</div>
